/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useState } from "react";
import "../assets/styles/splash.scss";

const SplashScreen = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulating loading time
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  return (
    <div className="main">
      {loading ? (
        <div className="splash">
          <img src="/assets/images/loader.svg" width="200" className="splash-logo" alt="Loading spinner" />
          <h1>Welcome to Frayo Chefportal</h1>
          <h2>Loading...</h2>
        </div>
      ) : (
        <h1>Error</h1>
      )}
    </div>
  );
};

export { SplashScreen };
